import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmDocCategoryVO {
  id?: number
  parentId?: number
  name: string
  sort?: number
  remark?: string
  children?: FirmDocCategoryVO[]
}

export interface FirmDocVO {
  id?: number
  categoryId: number
  categoryName?: string
  title: string
  description?: string
  scopeType: string
  scopeId?: number
  scopeName?: string
  status?: string
  remark?: string
  versionNo?: number
  fileUrl?: string
  fileName?: string
  fileSize?: number
  mimeType?: string
  createTime?: string
  caseId?: number
}

export interface FirmDocPageReq extends PageParam {
  title?: string
  categoryId?: number
  scopeType?: string
  status?: string
}

export const FirmDocApi = {
  categoryTree: () =>
    request.get<FirmDocCategoryVO[]>({ url: '/lawyer/firm/admin/doc/category/tree' }),
  createCategory: (data: FirmDocCategoryVO) =>
    request.post({ url: '/lawyer/firm/admin/doc/category/create', data }),
  updateCategory: (data: FirmDocCategoryVO) =>
    request.put({ url: '/lawyer/firm/admin/doc/category/update', data }),
  deleteCategory: (id: number) =>
    request.delete({ url: '/lawyer/firm/admin/doc/category/delete?id=' + id }),
  create: (data: FirmDocVO) => request.post({ url: '/lawyer/firm/admin/doc/create', data }),
  update: (data: FirmDocVO) => request.put({ url: '/lawyer/firm/admin/doc/update', data }),
  delete: (id: number) => request.delete({ url: '/lawyer/firm/admin/doc/delete?id=' + id }),
  get: (id: number) => request.get<FirmDocVO>({ url: '/lawyer/firm/admin/doc/get?id=' + id }),
  page: (params: FirmDocPageReq) =>
    request.get<PageResult<FirmDocVO>>({ url: '/lawyer/firm/admin/doc/page', params }),
  newVersion: (data: { id: number; fileUrl: string; fileName?: string }) =>
    request.post({ url: '/lawyer/firm/admin/doc/new-version', data })
}

export const DOC_SCOPE_OPTIONS = [
  { value: 'FIRM', label: '全所' },
  { value: 'ORG', label: '指定组织' }
]

export const docScopeLabel = (scopeType?: string) =>
  DOC_SCOPE_OPTIONS.find((o) => o.value === scopeType)?.label || scopeType || '-'
